import {
  jiraStatusActionTypes,
  updateJiraIssueDescriptionActionTypes
} from './../actions/types';
import { createSelector } from 'reselect';
import { cachedRequestByIdReducer } from './helpers';

export const jiraStatusReducer =
  (successAction, fetchFailureAction, commentFailureAction) =>
    (state = {}, action) => {
      switch (action.type) {
        case successAction:
          const newState = { ...state };
          Object.keys(action.response).forEach(k => {
            if (newState[k]) {
              newState[k] = {
                ...newState[k],
                ...action.response[k]
              };
            } else {
              newState[k] = action.response[k];
            }
          });

          return newState;
        case commentFailureAction:
        case fetchFailureAction:
          localStorage.removeItem('authKey');
          return state;
        default:
          return state;
      }
    };

const jiraStatuses = cachedRequestByIdReducer(jiraStatusActionTypes, 'statuses',
  ['request'], () => jiraStatusReducer(
    jiraStatusActionTypes.success, jiraStatusActionTypes.failure,
    updateJiraIssueDescriptionActionTypes.failure)
);

export default jiraStatuses;

export const getJiraStatusState = state => state.jiraStatuses;

export const getJiraTicketsStatuses = state =>
  getJiraStatusState(state).statuses;

const closedTickets = ['Resolved', 'Closed', 'Done', 'Not Found'];

export const getJiraOpenTickets = createSelector(
  getJiraTicketsStatuses,
  (getJiraTicketsStatuses) => Object.keys(getJiraTicketsStatuses)
    .reduce((openTickets, ticket) => {
      if (closedTickets.indexOf(getJiraTicketsStatuses[ticket]) === -1)
        openTickets.push(ticket);
      return openTickets;
    }, [])
);





// WEBPACK FOOTER //
// src/reducers/jiraStatus.js